import { useAppService } from "@fero/hooks";
import { useQuery } from "@tanstack/react-query";
import { nominatedPurchasersKeys } from "../../query-keys";

interface GetDeliveryDetailsArgs {
  nominatedPurchaserId: string;
}

export const usePurchaserSavedDeliveryInfoListQuery = ({
  nominatedPurchaserId,
}: GetDeliveryDetailsArgs) => {
  const service = useAppService();
  return useQuery({
    queryKey:
      nominatedPurchasersKeys.getPurchaserSavedDeliveryInfoList(
        nominatedPurchaserId,
      ),
    queryFn: () =>
      service.getNominatedPurchaserSavedDeliveryInfoList({
        nominatedPurchaserId,
      }),
  });
};
